import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import {
    Chart,
    ChartConfiguration,
    ChartType,
    LinearScale,
    LineController,
    PointElement,
    LineElement,
    CategoryScale,
    Filler
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(
    LinearScale,
    LineController,
    PointElement,
    LineElement,
    CategoryScale,
    Filler,
    ChartDataLabels
);

@Component({
    selector: 'app-heart-rate-chart',
    templateUrl: './heart-rate-chart.component.html',
    styleUrls: ['./heart-rate-chart.component.css'],
})
export class HeartRateChartComponent implements OnInit, OnDestroy {
    chart: any;

    ngOnInit() {
        setTimeout(() => this.createChart(), 0);
    }

    @HostListener('window:resize')
    onResize() {
        if (this.chart) {
            this.chart.destroy();
            this.createChart();
        }
    }

    createChart() {
        const canvas = document.getElementById('heartRateChart') as HTMLCanvasElement;
        if (!canvas) return;

        const ctx = canvas.getContext('2d');
        if (!ctx) return;

        const data = {
            labels: ['日', '月', '火', '水', '木', '金', '土'],
            datasets: [
                {
                    label: '心拍数',
                    data: [60, 75, 65, 55, 120, 70, 85],
                    fill: true,
                    borderColor: 'white',
                    tension: 0.4,
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    pointBackgroundColor: 'white',
                    pointBorderColor: 'white',
                    pointRadius: (context: any) => {
                        const dataset = context.dataset;
                        const max = Math.max(...dataset.data);
                        return context.raw === max ? 4 : 0;
                    },
                    pointHoverRadius: 4,
                }
            ]
        };

        const config: ChartConfiguration = {
            type: 'line' as ChartType,
            data: data,
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: {
                        min: 50,
                        max: 150,
                        position: 'right',
                        grid: {
                            display: false
                        },
                        ticks: {
                            color: 'white',
                            font: {
                                size: 14
                            },
                            stepSize: 50,
                        },
                        border: {
                            display: false
                        }
                    },
                    x: {
                        grid: {
                            display: false
                        },
                        ticks: {
                            color: 'white',
                            font: {
                                size: 14
                            }
                        },
                        border: {
                            display: false
                        }
                    }
                },
                plugins: {
                    legend: {
                        display: false
                    },
                    datalabels: {
                        color: 'white',
                        align: 'top',
                        anchor: 'center',
                        backgroundColor: '#6366F1',
                        borderRadius: 16,
                        padding: {
                            left: 16,
                            right: 16,
                            top: 4,
                            bottom: 4
                        },
                        formatter: function (value: number, context: any) {
                            const dataset = context.dataset;
                            const max = Math.max(...dataset.data);
                            return value === max ? value.toString() : null;
                        },
                        font: {
                            size: 14,
                            weight: 'bold'
                        }
                    }
                }
            }
        };

        this.chart = new Chart(ctx, config);
    }

    ngOnDestroy() {
        if (this.chart) {
            this.chart.destroy();
        }
    }
}